module.exports = __webpack_public_path__ + "img/openabacus.5889af9b.svg";